import * as types from "../../actions/sidebar";

export const setSidebarOpenState = (status: boolean) =>
    ({
        type: types.SidebarTypes.SET_OPEN_STATE,
        payload: status
    } as types.SidebarOpenState);
